import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = `https://apii.digically.in/api/teams/team/`;

const authHeader = () => {
  const token = localStorage.getItem("access");
  return token
    ? { Authorization: `Bearer ${token}` }
    : {};
};
/* ================= FETCH ================= */
export const fetchTeams = createAsyncThunk(
  "teams/fetchTeams",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(API_URL, {
        headers: authHeader(), // optional if protected
      });
      return res.data.results;
    } catch (err) {
      return rejectWithValue("Failed to fetch teams");
    }
  }
);

/* ================= CREATE ================= */
export const createTeam = createAsyncThunk(
  "teams/createTeam",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(API_URL, data, {
        headers: { 
          "Content-Type": "multipart/form-data",
          ...authHeader(), 
         },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue("Failed to create team member");
    }
  }
);

/* ================= UPDATE ================= */
export const updateTeam = createAsyncThunk(
  "teams/updateTeam",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${API_URL}${id}/`, data, {
        headers: { 
          "Content-Type": "multipart/form-data",
          ...authHeader(), 
         },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue("Failed to update team member");
    }
  }
);

/* ================= DELETE ================= */
export const deleteTeam = createAsyncThunk(
  "teams/deleteTeam",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}${id}/`, {
        headers: authHeader(),
      });
      return id;
    } catch (err) {
      return rejectWithValue("Failed to delete team member");
    }
  }
);

const teamSlice = createSlice({
  name: "teams",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      /* Fetch */
      .addCase(fetchTeams.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTeams.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* Create */
      .addCase(createTeam.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      })

      /* Update */
      .addCase(updateTeam.fulfilled, (state, action) => {
        const index = state.items.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) state.items[index] = action.payload;
      })

      /* Delete */
      .addCase(deleteTeam.fulfilled, (state, action) => {
        state.items = state.items.filter(
          (item) => item.id !== action.payload
        );
      });
  },
});

export default teamSlice.reducer;
